// key709 ~ 
const inverterDetail = {
  ko: {
    key709: '정렬선택',
    key710: '인버터',
    key711: '번호',
    key712: '시간',
    key713: '시리얼번호',
    key714: '현재출력(kW)',
    key715: '누적발전량(kWh)',
    key716: 'DC전류(A)',
    key717: 'DC전압(V)',
    key718: 'DC출력(W)',
    key719: '편집',
    key720: '세부정보',
    key721: '조회된 결과가 없습니다.',
    key722: '상세정보',
    key723: '시간',
    key724: '출력',
    key725: '누적발전량(kWh)',
    key726: 'DC전압',
    key727: 'DC전류',
    key728: 'DC출력',
    key729: 'R상전압',
    key730: 'S상전압',
    key731: 'T상전압',
    key732: 'R상전류',
    key733: 'S상전류',
    key734: 'T상전류',
    key735: '온도',
    key736: '주파수',
    key737: '상태코드',
    key738: '저장',
    key739: '취소',
  },
  en: {
    key709: 'Sort Option',
    key710: 'Inverter',
    key711: 'Number',
    key712: 'Time',
    key713: 'Serial Number',
    key714: 'Current Output (kW)',
    key715: 'Cumulative Generation (kWh)',
    key716: 'DC Current (A)',
    key717: 'DC Voltage (V)',
    key718: 'DC Output (W)',
    key719: 'Edit',
    key720: 'Detailed Information',
    key721: 'No data found.',
    key722: 'Detail Information',
    key723: 'Time',
    key724: 'Output',
    key725: 'Cumulative Generation (kWh)',
    key726: 'DC Voltage',
    key727: 'DC Current',
    key728: 'DC Output',
    key729: 'R-Phase Voltage',
    key730: 'S-Phase Voltage',
    key731: 'T-Phase Voltage',
    key732: 'R-Phase Current',
    key733: 'S-Phase Current',
    key734: 'T-Phase Current',
    key735: 'Temperature',
    key736: 'Frequency',
    key737: 'Status Code',
    key738: 'Save',
    key739: 'Cancel',
  },
  vi: {
    key709: 'Tùy chọn sắp xếp',
    key710: 'Bộ biến đổi (Inverter)',
    key711: 'Số thứ tự',
    key712: 'Thời gian',
    key713: 'Số sê-ri',
    key714: 'Công suất hiện tại (kW)',
    key715: 'Sản lượng tích lũy (kWh)',
    key716: 'Dòng điện DC (A)',
    key717: 'Điện áp DC (V)',
    key718: 'Công suất DC (W)',
    key719: 'Chỉnh sửa',
    key720: 'Thông tin chi tiết',
    key721: 'Không tìm thấy dữ liệu phù hợp.',
    key722: 'Thông tin chi tiết',
    key723: 'Thời gian',
    key724: 'Công suất',
    key725: 'Sản lượng điện tích lũy (kWh)',
    key726: 'Điện áp DC',
    key727: 'Dòng điện DC',
    key728: 'Công suất DC',
    key729: 'Điện áp pha R',
    key730: 'Điện áp pha S',
    key731: 'Điện áp pha T',
    key732: 'Dòng điện pha R',
    key733: 'Dòng điện pha S',
    key734: 'Dòng điện pha T',
    key735: 'Nhiệt độ',
    key736: 'Tần số điện',
    key737: 'Mã trạng thái',
    key738: 'Lưu',
    key739: 'Hủy',
  },
}
export default inverterDetail;